var _excluded = ["disabled"],
    _excluded2 = ["className", "classNameInput", "small", "codeNumber", "value", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import cx from "classnames";
import Select from "react-select";
import codeNumbers from "./codeNumbers";
import "./inputPhone.scss";

var InpputPhone = function InpputPhone(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  var className = props.className,
      classNameInput = props.classNameInput,
      small = props.small,
      codeNumber = props.codeNumber,
      value = props.value,
      _onChange = props.onChange,
      otherInputProps = _objectWithoutProperties(props, _excluded2);

  var defaultCodeNumber = codeNumber || "56";
  var selectedCodeNumber = defaultCodeNumber && codeNumbers.find(function (code) {
    return code.value === defaultCodeNumber;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx("cntInputPhone", className && className)
  }, /*#__PURE__*/React.createElement("label", {
    className: cx("cntInputPhone_label")
  }, "Tel\xE9fono"), /*#__PURE__*/React.createElement("div", {
    className: "ontainer-fluid row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(Select, {
    options: codeNumbers,
    value: selectedCodeNumber,
    isSearchable: true,
    isDisabled: disabled,
    placeholder: "Código...",
    onChange: function onChange(item) {
      return _onChange && _onChange(value, item.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon",
    id: "basic-addon1"
  }, "+".concat(defaultCodeNumber || "")), /*#__PURE__*/React.createElement("input", _extends({}, otherInputProps, {
    value: value || "",
    className: cx("cntInputPhone_field", classNameInput && classNameInput),
    placeholder: "Ingresar número...",
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange && _onChange(event.target.value, codeNumber);
    }
  }))))));
};

export default InpputPhone;